import type { ExamSection, QuestionType } from '@examflow/core';
import { createSectionConstraint } from '@examflow/core';
import {
  deleListeningDefinition,
  deleReadingDefinition,
  deleWritingDefinition,
} from './questionTypes';

/**
 * DELE 阅读理解部分配置
 */
export const DELE_READING_SECTION: ExamSection = {
  id: 'reading',
  name: '阅读理解 (Comprensión de lectura)',
  duration: 60,
  /**
   * B2-scale reading reference (~30 items). Real DELE papers vary by level
   * (A1≈20 … C2≈40); lock per-level configs when product ships level-specific mocks.
   */
  questionCount: 30,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(deleReadingDefinition.id)],
};

/**
 * DELE 听力理解部分配置
 */
export const DELE_LISTENING_SECTION: ExamSection = {
  id: 'listening',
  name: '听力理解 (Comprensión auditiva)',
  duration: 40,
  /** B2-scale listening reference for platform full mock. */
  questionCount: 30,
  questionTypes: ['single_choice' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(deleListeningDefinition.id)],
};

/**
 * DELE 书面表达部分配置
 */
export const DELE_WRITING_SECTION: ExamSection = {
  id: 'writing',
  name: '书面表达 (Expresión e interacción escritas)',
  duration: 60,
  /** Two writing tasks. */
  questionCount: 2,
  questionTypes: ['fill_blank' as QuestionType],
  questionTypeConstraints: [createSectionConstraint(deleWritingDefinition.id)],
};

/**
 * DELE 口语表达部分配置（单独考试）
 *
 * Intentionally NOT in DELE_SECTIONS: DELE oral is a separate paper / appointment track.
 * Platform full mock covers reading + listening + writing only. Export kept for
 * Language Ops / future oral Training Session wiring — do not merge into mandatory mock.
 */
export const DELE_SPEAKING_SECTION: ExamSection = {
  id: 'speaking',
  name: '口语表达 (Expresión e interacción orales)',
  duration: 15,
  /** Oral interaction tasks (not in DELE_SECTIONS mandatory mock set). */
  questionCount: 3,
  questionTypes: ['fill_blank' as QuestionType],
};

/**
 * DELE 考试部分
 */
export const DELE_SECTIONS: ExamSection[] = [
  DELE_READING_SECTION,
  DELE_LISTENING_SECTION,
  DELE_WRITING_SECTION,
];

/**
 * 获取总考试时长（分钟）
 */
export function getTotalDuration(): number {
  return DELE_SECTIONS.reduce((sum, section) => sum + section.duration, 0);
}
